import {initTrustbars} from "../../../global/js/trustbar";
import {getChildrenClassForNestedItems} from "../../../global/js/nav";
import {closeFilterBox, initFilter} from "../../../global/js/filter";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../global/js/actionClick";
import {focusInputGroups} from "../../../global/js/checkInputGroups";
import {stickyHeader} from "../../../global/js/stickyheader";
import {triggerFavoritesBtns} from "../../../global/js/favorites";
import hoverintent from "../../../global/js/hoverintent";
import {initSlideshows} from "../../../global/js/slideshow";
import {openFullscreenGallery} from "../../../global/js/fullscreengallery";
import {stickyBox} from "../../../global/js/stickyBox.js";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "../../../global/js/mobilemenu";
import {excludeModal, triggerConfirmModalLink, triggerModal} from "../../../global/js/modal";
import {initToggleSlide} from "../../../global/js/toggle";
import {initItemlistSlider} from "../../../global/js/itemListSlider";
import {initScrollbars} from "../../../global/js/scrollbar";
import {isTouchDevice} from "../../../global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../global/js/customSelect";
import {initJumpmarks} from "../../../global/js/jumpmark";
import {initSearchItems} from "../../../global/js/searchItems";
import {initItemlistToggle} from "../../../global/js/itemlistToggle";
import {initPriceListGraduated} from "../../../global/js/priceListGraduated";
import {lottieLoader} from "../../../global/js/lottieLoader";
import {initFlashmessages} from "../../../global/js/flashmessages";
import {initPasswordFields} from "../../../global/js/password";
import {trimInputValues} from "../../../global/js/formValidator";
import {initSlidecontents} from "../../../global/js/slidecontent";
import {initPhoneCountryFields} from "../../../global/js/phoneCountryField";
import {initInputBody} from "../../../global/js/inputfile";
import {initImageGallery} from "../../../global/js/imageGallery";
import {initAjaxCollectionFilter} from "../../../global/js/ajaxCollectionFilter";
import {initDatepicker} from "../../../global/js/datepicker";
import {initHistorySlider} from "../../../global/js/history";
import {initContentTabs} from "../../../global/js/contentTabs";
import {initScrollActivate} from "../../../global/js/scrollactivate";
import {initRangeslider} from "../../../global/js/rangeSlider";
import {initRecaptchaForms} from "../../../global/js/recaptchaForm";
import {initFlyout} from "../../../global/js/flyoutMenu";
import {initHighlightEditors} from "../../../global/ts/highlightEditor";
import {maxHeightContent} from "../../../global/js/maxHeightContent";
import {initAjaxFormApi} from "../../../global/js/ajaxFormApi";
import {langSwitchByHrefLang} from "../../../global/js/langSwitchByHrefLang";

window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        buildMobileMenu(mobileMenu);

        mobileMenuToggle.addEventListener("click", function () {
            showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        mobileMenuClose.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            for (const filterbox of document.querySelectorAll('.filterBox')) {
                closeFilterBox(filterbox);
            }
        });
    }

    initTrustbars();

    initFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    focusInputGroups();

    trimInputValues();

    initInputBody();

    initPasswordFields();

    initPhoneCountryFields();

    stickyHeader(stickyHeaderArea);

    if (window.outerWidth < breakPointSM) {
        for (const parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }

    triggerModal();
    excludeModal();
    triggerConfirmModalLink();

    initToggleSlide();

    initFlashmessages();

    if (!IsTouchDevice) {
        for (const el of document.querySelectorAll('.itembox,.iconbarItem')) {
            hoverintent(el);
        }
    }
    for (const el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }

    initImageGallery();

    initSlideshows();

    initScrollbars();

    initSlidecontents();

    initItemlistSlider(document.querySelectorAll('.itemboxList.swiper'),{
        breakpointItems: {
            xs: 1.7,
            sm: 3,
            md: 4,
            lg: 4,
            xlg: 5
        }
    });

    initCustomSelects();

    // Tooltip, when necessary
    // import {Tooltip} from "../../../default/global/js/tooltip-custom";

    //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //    return new Tooltip(tooltipTriggerEl);
    //});

    initSearchItems(document.querySelectorAll('.js-searchInput'));

    let offsetTopJumpmarks = 0;
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    if (typeof GLOBALS!== "undefined") {
        if(GLOBALS.offsetTopJumpmarks){
            offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
        }
    }

    initJumpmarks(offsetTopJumpmarks);

    let iopenGallery =  0;
    for (const item of document.querySelectorAll(".js-openGallery")) {
        if(!item.dataset.index){
            item.setAttribute("data-index",iopenGallery);
        }
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
        iopenGallery++;
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    for (const pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }
    lottieLoader();

    initItemlistToggle();

    initPriceListGraduated();

    initAjaxCollectionFilter();

    initAjaxFormApi();

    initDatepicker();

    initHistorySlider();

    initFlyout();

    initContentTabs();

    initScrollActivate();

    initRangeslider(document,function (e){
        if(e.slider.closest(".js-customSelect")){
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"),e.value);
        }
    });

    initRecaptchaForms();

    initHighlightEditors();

    maxHeightContent();
    langSwitchByHrefLang();

    window.main = {
        hideAllCustomSelect: function (){
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select){
            hideCustomSelect(select);
        }
    };
});